var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55841 3.425L7.09174 6.35833C6.89174 6.76667 6.35841 7.15833 5.90841 7.23333L3.25008 7.675C1.55008 7.95833 1.15008 9.19167 2.37508 10.4083L4.44174 12.475C4.79174 12.825 4.98341 13.5 4.87508 13.9833L4.28341 16.5417C3.81674 18.5667 4.89174 19.35 6.68341 18.2917L9.17508 16.8167C9.62508 16.55 10.3667 16.55 10.8251 16.8167L13.3167 18.2917C15.1001 19.35 16.1834 18.5583 15.7167 16.5417L15.1251 13.9833C15.0167 13.5 15.2084 12.825 15.5584 12.475L17.6251 10.4083C18.8417 9.19167 18.4501 7.95833 16.7501 7.675L14.0917 7.23333C13.6501 7.15833 13.1167 6.76667 12.9167 6.35833L11.4501 3.425C10.6501 1.83333 9.35008 1.83333 8.55841 3.425Z",
    fill: "#8EE1E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.3c0b032dc74e13fa214ce9916f4c3bfe.svg";
export { ForwardRef as ReactComponent };